/**
 * msIncome 认证配置
 * 采用与 msAdmin 相同的配置模式，使用 @ms/shared-config
 */

import { createServiceAuthConfig } from '@ms/shared-config';

// 当前微服务名称 - 与数据库中的service_name保持一致
export const CURRENT_SERVICE_NAME = 'msincome';

/**
 * msIncome 认证配置
 * 使用集中化配置生成，与 msAdmin 保持一致
 */
const baseConfig = createServiceAuthConfig('msincome');

const resolveApiBaseUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    if (hostname.includes('homaxs.com') || hostname.includes('idtree.cn')) {
      return 'http://www.homaxs.com';
    }

    return window.location.origin;
  }

  return (
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    baseConfig.apiBaseUrl
  );
};

export const msIncomeAuthConfig = {
  ...baseConfig,
  apiBaseUrl: resolveApiBaseUrl()
};
